import {BankAccount} from '../company/company.model';

export class PortNumberOffer {
  appliance_id: number;
  number_blocks: PortNumberBlockDetails[];
  payment_details: PortNumberBankAccount;
  phonebill_file: PortNumberUploadForm;
  porting_form_file: PortNumberUploadForm;
  bill_company_name: string;
  delivery_date: string;
  partner_id?: number = undefined;
  losing_provider: string;
}

export class PortNumberBlockDetails {
  country_prefix: string;
  area_code: string;
  main_number: string;
  block_start: string;
  block_end: string;

  // +areaCode (+) will transform string into number on the output of the condition
  // to be sure to have no leading 0 for area code
  // E.g. area code: 030 on input transformed into 30 for preview.
  preview() {
    return '+' + (+this.country_prefix) + ' '
      + (+this.area_code > 0 ? +this.area_code : '') + ' '
      + (+this.main_number > 0 ? +this.main_number : '');
  }

  format() {
    return this.country_prefix
    + (+this.area_code > 0 ? +this.area_code : '')
    + this.main_number;
  }

  previewBlock() {
    const main = '+' + (+this.country_prefix) + ' '
      + (+this.area_code > 0 ? +this.area_code : '') + ' '
      + (+this.main_number > 0 ? +this.main_number : '');

    return {
      start: main + ' ' + this.formatLeadingZeros(this.block_start, this.block_end),
      end: main + ' ' + this.block_end,
    }
  }

  formatLeadingZeros(start: string, end: string): string {
    if (start.length < end.length) {
      const len = end.length - start.length;
      return new Array(len + 1).join('0') + start;
    } else if (start.length > end.length) {
      return +start + '';
    }
    return start;
  }
}

export class PortNumberBlockDetailsWithPreview extends PortNumberBlockDetails {
  previewNumber: string;
}

export class PortNumberUploadForm {
  file_name: string;
  file_body_b64: string;
  file?: File;
}

export class PortNumberBankAccount extends BankAccount {}

export interface PortformCustomAddress {
  street: string;
  house_number: string;
  zip: string;
  city: string;
}

export class PortNumbersPortingFormDetails {
  provider: string;
  company_name: string;
  numbers: PortNumberBlockDetails[];
  company_id: number;
  cancel_connection: boolean;
  custom_address?: PortformCustomAddress
}
